<template>
  <div class="btn-group p-3" role="group" aria-label="View mode">
    <button class="btn btn-default" :class="{active: mode === 'mobile'}" @click="$emit('switch-mode', 'mobile')">
      Mobile
    </button>
    <button class="btn btn-default" :class="{active: mode === 'desktop'}" @click="$emit('switch-mode', 'desktop')">
      Desktop
    </button>
  </div>
</template>

<script>
export default {
  name: 'page-preview-panel',
  props: {
    mode: {
      type: String,
      required: true,
    },
  },
};
</script>
